import useGetVariations from 'Pods/ThreeDStudio/Hooks/useGetVariations'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

// A chained enhancement only lists its parent run's output as input, so the upload is
// found across the whole session. The file url is not required: it is withheld from
// viewers who do not own the run, but the upload still marks the session's origin.
const hasUploadedModelInput = variation => (variation.inputAssets || []).some(asset => (
  asset.assetType === '3d_model' && asset.source === 'user_upload'
))

/**
 * Whether the model on screen is an upload, or was made from one.
 * @returns {boolean}
 */
export default function useIsUploadedModel() {
  const isUploadedModel = useThreeDStudioStore(state => !!state.modelSettings?.inputThreeDUrl)
  const generatorSessionId = useThreeDStudioStore(state => state.ui?.openedModel?.generatorSessionId)
  const { variations } = useGetVariations(isUploadedModel ? null : generatorSessionId)

  return isUploadedModel || variations.some(hasUploadedModelInput)
}
